import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Carousel } from '../core'

function getTransform(el) {
  var values = el.style.transform.split(/\w+\(|\);?/);
  if (!values[1] || !values[1].length) {
    return [];
  }
  return values[1].split(/,\s?/g);
}

$.fn.Product = function(cards) {
  let self = this

  if (self.data('product')) {
    return self.data('product')
  }

  self.name = self.attr('data-id')
  self.sections = self.find('.product__section').toArray()
  self.maxWidth = 0
  self.triggers = []

  function $el(name) {
    return self.find('[data-name="' + name + '"]')
  }

  function el(name) {
    return $el(name).get(0)
  }

  self.display = function() {
    self.attr('aria-hidden', 'false')
  }

  self.goodbye = function() {
    if (!$.mlmi.mobile.isMobile) {
      $('body, html').scrollTo(0, 200, 999)
    }
    self.find('.product__section:not(.bg-white)').fadeOut(450)
    self.find('.product__section.bg-white').find('.text-content, h2').fadeOut(350)
    setTimeout(function() {
      self.attr('aria-hidden', 'true')
      self.triggers.forEach(function(trigger) {
        trigger.kill()
      })
      self.triggers = []
      requestAnimationFrame(function() {
        $('#' + self.name).remove()
      })
      ScrollTrigger.refresh()
    }, 460)
  }

  self.updateMaxWidth = function() {
    let maxWidth = 0
    self.sections.forEach((section) => {
      maxWidth += section.offsetWidth
    })
    self.maxWidth = maxWidth
  }

  self.initialize_interface = function() {
    self.attr('id', self.attr('data-id'))
    if (cards != undefined && !$.mlmi.mobile.isMobile) {
      let cardsMenu = cards.clone().attr('data-name', 'product-cards')
      self.find('.product__title:first').before(cardsMenu)
      cardsMenu.find('.flavors__link').on('click', function() {
        cards.find('a[href="' + $(this).attr('href') + '"]').click()
        return false
      })
    }
    $el('product-brand').after($el('product-brand').clone().addClass('product-brand--white').attr('data-name', 'product-brand-white'))
    self.on('click', '[data-name="first-content"] .btn-secondary, .product-brand a, [data-name="down-button"] a, [data-name="home-down-button"] a', function(e) {
      e.preventDefault()
      let scrollAction = $(this).data('scroll-action')
      $('body').removeClass('--product-' + self.name)
      $('.product[aria-hidden="false"]').Product().goodbye()
      setTimeout(function() {
        $.mlmi.cards.return_to_cards(scrollAction)
      }, 360)
      return false
    })
  }

  self.initialize_carousel = function() {
    let carousel = new Carousel(self.get(0), {
      loop: false,
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: false,
    }, {
       desktop: false,
    })
    carousel.init()
    self.find('[data-name="back-button"] a').on('click', function(e) {
      e.preventDefault()
      carousel.swiper.slideTo(0)
      return false
    })
    self.find('[data-name="home-right-button"] a').on('click', function(e) {
      e.preventDefault()
      carousel.swiper.slideTo(1)
      return false
    })
    $('body').removeClass('--transition-phase-2')
  }

  self.initialize_scroll_trigger = function() {
    /* Calculate max width */
    self.updateMaxWidth()
    ScrollTrigger.addEventListener('refreshInit', self.updateMaxWidth)

    /* Initialize gsap horizontal scroller */
    self.triggers.push(gsap.to(self.sections, {
      x: () => `-${self.maxWidth - window.innerWidth}`,
      ease: 'none',
      onUpdate: function(st) {
        let logoInset = parseFloat(getTransform(self.sections[0])[0])
        $el('product-brand').css('clip-path', `inset(0px ${-logoInset}px 0px 0px)`)
        $el('product-brand-white').css('clip-path', `inset(0px 0px 0px ${window.innerWidth + logoInset}px)`)
      },
      scrollTrigger: {
        trigger: self.get(0),
        pin: true,
        scrub: .666,
        end: () => `+=${self.maxWidth - window.innerWidth}`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)

    /* Transition to horizontal */
    gsap.to(el('main-title'), {
      opacity: 1,
      duration: .35,
    })
    let firstContentFadeIn = gsap.to(el('first-content'), {
      opacity: 1,
      duration: .35,
      delay: .1,
    })

    /* Horizontal scrub */
    self.triggers.push(gsap.to(el('main-title'), {
      x: () => `+=${window.innerWidth}px`,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top top`,
        end: () => `+=${window.innerWidth}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('product-cards'), {
      x: () => `+=${window.innerWidth}px`,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top top`,
        end: () => `+=${window.innerWidth}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('first-content'), {
      x: () => `+=${window.innerWidth}px`,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top top`,
        end: () => `+=${window.innerWidth}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    setTimeout(function() {
      self.triggers.push(gsap.to(el('first-content'), {
        opacity: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: el('title-section'),
          scrub: .666,
          start: () => `top top`,
          end: () => `+=${window.innerWidth / 3}px`,
          invalidateOnRefresh: true,
        }
      }).scrollTrigger)
      ScrollTrigger.refresh()
      $('body').removeClass('--transition-phase-2')
    }, 350)
    self.triggers.push(gsap.from(el('alt-title'), {
      x: () => `-=${window.innerWidth}px`,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top top`,
        end: () => `+=${window.innerWidth}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.from(el('ingredients'), {
      x: () => `-=${window.innerWidth}px`,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top top`,
        end: () => `+=${window.innerWidth}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('ingredients'), {
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${window.innerWidth * .56}px`,
        end: () => `+=${window.innerWidth * .25}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('accord-avec'), {
      x: '-=80vw',
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${window.innerWidth * 1.3}px`,
        end: () => `+=${self.maxWidth - window.innerWidth}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('accord-manger'), {
      x: '+=115vw',
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${window.innerWidth * 2}px`,
        end: () => `+=${self.maxWidth - window.innerWidth}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('track'), {
      x: () => `+=${(self.maxWidth - window.innerWidth) - (window.innerWidth * 2.6)}px`,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${window.innerWidth * 2.6}px`,
        end: () => `+=${(self.maxWidth - window.innerWidth) - (window.innerWidth * 2.6)}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('track'), {
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${window.innerWidth * 2.9}px`,
        end: () => `+=250px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('track'), {
      opacity: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${self.maxWidth - window.innerWidth * 2 - 175}px`,
        end: () => `+=250px`,
        invalidateOnRefresh: true,
        toggleClass: {
          targets: el('track'),
          className: 'active',
        },
        onLeave: function() {
          $el('track').addClass('after')
        },
        onEnterBack: function() {
          $el('track').removeClass('after')
        },
      }
    }).scrollTrigger)
    self.triggers.push(gsap.from(el('outro-content'), {
      x: () => `-=${window.innerWidth * 2}px`,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${self.maxWidth - window.innerWidth * 3}px`,
        end: () => `+=${window.innerWidth * 2}px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('outro-paragraph'), {
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${self.maxWidth - window.innerWidth * 1.85}px`,
        end: () => `+=350px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('buy-button'), {
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${self.maxWidth - window.innerWidth * 1.5}px`,
        end: () => `+=350px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)
    self.triggers.push(gsap.to(el('down-button'), {
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: el('title-section'),
        scrub: .666,
        start: () => `top -${self.maxWidth - window.innerWidth * 1.5}px`,
        end: () => `+=350px`,
        invalidateOnRefresh: true,
      }
    }).scrollTrigger)

    ScrollTrigger.refresh(true)
  }

  self.initialize_animations = function() {
    if ($.mlmi.mobile.isMobile) {
      self.initialize_carousel()
    } else {
      self.initialize_scroll_trigger()
    }
  }

  return function() {
    self.initialize_interface()
    self.data('product', self)
    return self
  }()
}
